import { useMediaQuery, useTheme } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { checkPermission, renderDate } from "../../../../utils/app.utils";
import OptionsButtonCustom from "../../../../components/option-button/OptionsButtonCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, unsetLoading } from "../../../../store/loading/loading.slice";
import moment from "moment";
import { alertActive, alertError, alertSuccess } from "../../../../components/alert/swal";
import { useNavigate } from "react-router-dom";
// import { RoutePath } from "../../../routes/Routes";
import { banner_type_data, CONTENT_TYPE, STATUS_ENUM } from "./enum/content.enum";
// import { renderStatus } from "../../manage-articles/enum/article.enum";
import { ContentApi, contentList } from "../../../../api/content/content.api";
import SwitchCustom from "../../../../components/switch/SwitchCustom";
import { RootState } from "../../../../store/store";
import { routeName } from "../../../../routes/routeName";
import { useTranslation } from "react-i18next";

export const ManageState = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));
    const navigate = useNavigate();

    const profileReducer = useSelector((state: RootState) => state.profile.profile);
    const permission: any[] = profileReducer?.permission || [];
    const checkPermit = checkPermission('WEBSITE_STRUCTURE_CONTENT', permission);


    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [search, setSearch] = useState<string>("");
    const [startDate, setStartDate] = useState<string | null>("");
    const [data, setData] = useState<any[]>([]);
    const [endDate, setEndDate] = useState<string | null>("");
    const [banner_type, set_banner_type] = useState<string>("");

    const [id_information_source, set_id_information_source] = useState<any>(null);

    const headCell = [
        {
            id: "seq", width: 50, sortable: true, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "1", disablePadding: false, width: 200, sortable: false, align: "left", label: t("ชื่อ")
        },
        {
            id: "2", disablePadding: false, width: 100, sortable: false, align: "center", label: t("แพทเทิร์น")
        },
        {
            id: "22", disablePadding: false, width: 80, sortable: false, align: "center", label: t("สถานะ")
        },
        {
            id: "3", disablePadding: false, width: 100, sortable: false, align: "center", label: t("ผู้สร้าง/แก้ไขล่าสุด")
        },
        {
            id: "4", disablePadding: false, width: 90, sortable: false, align: "center", label: t("วันที่สร้าง/แก้ไขล่าสุด")
        },
        {
            id: "action", disablePadding: false, align: "left", class: matches && data.length > 0, width: 70, label: ""
        },
    ];


    const handleChangeDateRange = (st_date: string | null, end_date: string | null) => {
        setStartDate(st_date)
        setEndDate(end_date)
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            modified_date,
            modified_by,
            created_date,
            content_name,
            status,
            // content_start_date,
            // content_start_time,
            // content_end_date,
            // content_end_time,
            id_content,
            modified_name,
            create_name,
            is_public,
            banner_type
        } =
            objData;

        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: content_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: t(banner_type_data?.find((x) => x.value === banner_type)?.label || "-"),
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: <div className="flex justify-center items-center">
                        <SwitchCustom
                            checked={status === STATUS_ENUM.ACTIVE ? true : false}
                            onChange={(st) => handleUpdateStatus(id_content, st ? STATUS_ENUM.ACTIVE : STATUS_ENUM.INACTIVE)}
                        />
                    </div>
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_name ? modified_name : create_name ? create_name : "-",
                    // label: (modified_by?.employee_name && modified_by?.employee_last_name) ? `${modified_by?.employee_name} ${modified_by?.employee_last_name}` : "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? renderDate(modified_date) : created_date ? renderDate(created_date) : "-"
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches,
                    component:
                        <div className="flex justify-center items-center">
                            <span>
                                <OptionsButtonCustom
                                    enableView={checkPermit.isView}
                                    enableEdit={(status === STATUS_ENUM.DRAFT || !Number(is_public)) && checkPermit.isUpdate}
                                    enableDelete={checkPermit.isDelete}
                                    onDeleteClick={() => handleDeleteContent(id_content)}
                                    onViewClick={() => navigate(routeName.cms_website.website_structure_content_view.replace(":id", id_content))}
                                    onEditClick={() => navigate(routeName.cms_website.website_structure_content_detail.replace(":id", id_content))}
                                />
                            </span>
                        </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleUpdateStatus = async (id_content: number, status: string) => {
        await ContentApi.updateStatusContent(id_content, {
            status: status
        }).then((res) => {
            if (res.status < 300) {
                handleGetData();
            }
        }).catch((err) => {
            console.log(err)
            alertError(t("อัพเดตสถานะไม่สำเร็จ"))
        })
    }
    const handleDeleteContent = (id_content: number) => {
        alertActive(t("ลบรายการ"), t("ท่านต้องการลบรายการนี้?"), undefined, undefined, async () => {
            dispatch(setLoading());
            await ContentApi.updateStatusContent(id_content, { status: STATUS_ENUM.DELETED }).then((res) => {
                if (res.status < 300) {
                    handleGetData();
                    alertSuccess(t("ลบรายการ"), t("ลบรายการ เรียบร้อย"))
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("ลบรายการ"), t("ลบรายการ ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }

    const handleGetData = useCallback(async () => {
        let query: contentList = {
            page,
            limit: pageLimit,
            sortBy,
            sortType,
            content_type: CONTENT_TYPE.CONTENT
        }
        if (search) query = { ...query, keyword: search }
        if (banner_type) query = { ...query, banner_type: banner_type }
        if (startDate && endDate) query = {
            ...query,
            end_date: moment(endDate).format("YYYY-MM-DD"),
            start_date: moment(startDate).format("YYYY-MM-DD"),
        }
        dispatch(setLoading());
        await ContentApi.list(query).then((res) => {
            if (res.status < 300) {
                const data = res?.data?.data?.items || []
                setData(data)
                setTotalItems(res.data?.data?.meta?.totalItems || 0);
            }
        }).catch((err) => console.log(err)).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, sortBy, sortType, startDate, search, , endDate, banner_type])

    useEffect(() => {
        handleGetData();
    }, [handleGetData])

    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        handleRequestSort,
        sortBy,
        sortType,
        renderData,
        headCell,
        totalItems,
        data,
        setSearch,
        handleChangeDateRange,
        startDate,
        endDate,
        id_information_source,
        set_id_information_source,
        banner_type,
        set_banner_type,
        checkPermit
    }
}